import { Component } from '@angular/core';
import { PageTitleComponent } from "@shared/components/page-title/page-title.component";

@Component({
  selector: 'app-building-plan',
  standalone: true,
  imports: [
    PageTitleComponent
  ],
  templateUrl: './building-plan.component.html',
  styleUrl: './building-plan.component.scss'
})
export class BuildingPlanComponent {
  breadCrumbItems = [
    {
      label: 'Smart Controller',
    },
    {
      label: 'Home Controller',
      active: true,
    }
  ]
}
